// src/store/userStore.ts
import { defineStore } from "pinia";
import Cookies from "js-cookie";

export const useAppStore = defineStore("app", {
  state: () => ({
    loading: false,
  }),
  actions: {
    setLoading(status: boolean) {
      this.loading = status;
    },
  },
});

export const useUserStore = defineStore("user", {
  state: () => ({
    user: null as {
      name: string;
      email: string;
      role: string;
      defaultPlan: any;
      byAgents: any;
    } | null,
  }),
  actions: {
    setUser(userData: {
      name: string;
      email: string;
      role: string;
      defaultPlan: any;
      byAgents: any;
    }) {
      this.user = {
        ...this.user,
        ...userData,
      };

      // ✅ Set cookie to expire in  minutes
      const expirationMinutes = 1140;
      const expiresAt = new Date(
        new Date().getTime() + expirationMinutes * 60000
      );
      Cookies.set("loginExpiresAt", expiresAt.toISOString(), { expires: 1, path: "/" });
    },

    clearUser() {
      this.user = null;
      Cookies.remove("loginExpiresAt", { path: "/" }); // ✅ Clear cookie
    },

    checkSessionExpiry() {
      const loginExpiresAt = Cookies.get("loginExpiresAt");
      if (loginExpiresAt) {
        const now = new Date();
        const expiry = new Date(loginExpiresAt);
        if (now > expiry) {
          this.clearUser(); // logout
          return false;
        }
      }
      return true;
    },
  },
  getters: {
    isAuthenticated: (state) => !!state.user,
    userRole: (state) => state.user?.role || "",
  },
  persist: true,
});

export const useChangePlanStore = defineStore("changePlan", {
  state: () => ({
    active: "main",
  }),
  actions: {
    handlePlan(data: string) {
      this.active = data;
    },
    clearUser() {
      this.active = "";
    },
  },
  getters: {
    plan: (state) => state.active,
  },
});

export const currentWebStore = defineStore("currentWebStore", {
  state: () => ({
    webId: null,
  }),
  actions: {
    handleWebId(data: any) {
      this.webId = data;
    },
    clearUser() {
      console.log("clearUser called"); // 👈 console log
      this.webId = null;
    },
  },
  getters: {
    getWebId: (state) => state.webId,
  },
});

export const currentWebSiteData = defineStore("currentWebData", {
  state: () => ({
    webData: {},
  }),
  actions: {
    handleWebData(data: any) {
      this.webData = {
        ...this.webData,
        ...data,
      };
    },
    clearUser() {
      console.log("clearUser called"); // 👈 console log
      this.webData = {};
    },
  },
  getters: {
    getWebId: (state) => state.webData,
  },
});

export const googleAuth = defineStore("googleAuth", {
  state: () => ({
    googleAuth: {
      isLogin: false,
    },
  }),
  actions: {
    handleAuthData(data: any) {
      this.googleAuth = {
        ...this.googleAuth,
        ...data,
      };
    },
    clearUser() {
      console.log("clearUser called"); // 👈 console log
      this.googleAuth = {
        isLogin: false,
      };
    },
  },
  getters: {
    getWebId: (state) => state.googleAuth,
  },
});
